export default "__VITE_ASSET__Q7FsFMCS__"